module.exports = require("@bechtel/client-assets/dist/images/empty-state_user-detail.svg");